import { Cell } from '@table-library/react-table-library/table';
import { showPlatform } from '../../../PromptManager/keys';
import Tags from '../../../projects/components/tags';

export const COLUMNS = (t, isDark, selectedItems) => [
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.prompt'),
        key: 'prompt',
        data: 'prompt',
        Component: Cell,
        colSpan: 2,
        cellSize: 'minmax(250px, 2.5fr)',
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <div>
                    <div
                        className={`wrap-text ${
                            item.status === 'inactive' ? 'inactive-status' : ''
                        }`}
                    >
                        {data}
                    </div>
                    <div className="ai-tracking-project-name-bottom tags-box mt-5">
                        <Tags items={item.tags} shownCount={1} />
                    </div>
                </div>
            );
        },
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.checks'),
        key: 'checks',
        data: 'checks',
        Component: Cell,
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.own_unique_urls'),
        key: 'ownUniqueURLs',
        data: 'ownUniqueURLs',
        Component: Cell,
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.citations_sov'),
        key: 'citationsSoV',
        data: 'citationsSoV',
        Component: Cell,
        renderCell: ({ data }) => (data !== 'na' ? `${(Number(data) * 100).toFixed(2)}%` : '-'),
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.citation_rate'),
        key: 'citationRate',
        data: 'citationRate',
        Component: Cell,
        renderCell: ({ data }) => (data !== 'na' ? `${(Number(data) * 100).toFixed(2)}%` : '-'),
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.mentions_rate'),
        key: 'mentions_rate',
        data: 'mentions_rate',
        Component: Cell,
        renderCell: ({ data }) => (data !== 'na' ? `${(Number(data) * 100).toFixed(2)}%` : '-'),
    },

    // ChatGPT
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.sov'),
        key: 'SoV_chatgpt',
        data: 'SoV_chatgpt',
        Component: Cell,
        className: (item) => {
            const isSelected = selectedItems.includes(item?.id);
            const styleClass = isDark ? 'header-platform-column-dark' : 'header-platform-column';
            return `${styleClass} ${isSelected ? 'selected' : ''}`;
        },
    },
    {
        label: (
            <div style={{ whiteSpace: 'pre-line' }}>
                {t('ai_tracking.keyword_detail.prompts.columns.own_urls')}
            </div>
        ),
        key: 'ownURLs_chatgpt',
        data: 'ownURLs_chatgpt',
        Component: Cell,
        className: (item) => {
            const isSelected = selectedItems.includes(item?.id);
            const styleClass = isDark ? 'header-platform-column-dark' : 'header-platform-column';
            return `${styleClass} ${isSelected ? 'selected' : ''}`;
        },
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.own_avg_position'),
        key: 'ownAvgPosition_chatgpt',
        data: 'ownAvgPosition_chatgpt',
        Component: Cell,
        className: (item) => {
            const isSelected = selectedItems.includes(item?.id);
            const styleClass = isDark ? 'header-platform-column-dark' : 'header-platform-column';
            return `${styleClass} ${isSelected ? 'selected' : ''}`;
        },
        renderCell: ({ data }) => (data !== 'na' ? `${(Number(data) * 100).toFixed(2)}` : '-'),
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.mentions_rate'),
        key: 'mentionsRate_chatgpt',
        data: 'mentionsRate_chatgpt',
        Component: Cell,
        className: (item) => {
            const isSelected = selectedItems.includes(item?.id);
            const styleClass = isDark ? 'header-platform-column-dark' : 'header-platform-column';
            return `${styleClass} ${isSelected ? 'selected' : ''}`;
        },
        renderCell: ({ data }) => (data !== 'na' ? `${(Number(data) * 100).toFixed(2)}%` : '-'),
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.own_citation_rate'),
        key: 'ownCitationRate_chatgpt',
        data: 'ownCitationRate_chatgpt',
        Component: Cell,
        className: (item) => {
            const isSelected = selectedItems.includes(item?.id);
            const styleClass = isDark ? 'header-platform-column-dark' : 'header-platform-column';
            return `${styleClass} ${isSelected ? 'selected' : ''}`;
        },
        renderCell: ({ data }) => (data !== 'na' ? `${(Number(data) * 100).toFixed(2)}%` : '-'),
    },

    // Perplexity
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.sov'),
        key: 'SoV_perplexity',
        data: 'SoV_perplexity',
        Component: Cell,
    },
    {
        label: (
            <div style={{ whiteSpace: 'pre-line' }}>
                {t('ai_tracking.keyword_detail.prompts.columns.own_urls')}
            </div>
        ),
        key: 'ownURLs_perplexity',
        data: 'ownURLs_perplexity',
        Component: Cell,
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.own_avg_position'),
        key: 'ownAvgPosition_perplexity',
        data: 'ownAvgPosition_perplexity',
        Component: Cell,
        renderCell: ({ data }) => (data !== 'na' ? `${(Number(data) * 100).toFixed(2)}` : '-'),
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.mentions_rate'),
        key: 'mentionsRate_perplexity',
        data: 'mentionsRate_perplexity',
        Component: Cell,
        renderCell: ({ data }) => (data !== 'na' ? `${(Number(data) * 100).toFixed(2)}%` : '-'),
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.own_citation_rate'),
        key: 'ownCitationRate_preplexity',
        data: 'ownCitationRate_preplexity',
        Component: Cell,
        renderCell: ({ data }) => (data !== 'na' ? `${(Number(data) * 100).toFixed(2)}%` : '-'),
    },

    // Gemini
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.sov'),
        key: 'SoV_gemini',
        data: 'SoV_gemini',
        Component: Cell,
        className: (item) => {
            const isSelected = selectedItems.includes(item?.id);
            const styleClass = isDark ? 'header-platform-column-dark' : 'header-platform-column';
            return `${styleClass} ${isSelected ? 'selected' : ''}`;
        },
    },
    {
        label: (
            <div style={{ whiteSpace: 'pre-line' }}>
                {t('ai_tracking.keyword_detail.prompts.columns.own_urls')}
            </div>
        ),
        key: 'ownURLs_gemini',
        data: 'ownURLs_gemini',
        Component: Cell,
        className: (item) => {
            const isSelected = selectedItems.includes(item?.id);
            const styleClass = isDark ? 'header-platform-column-dark' : 'header-platform-column';
            return `${styleClass} ${isSelected ? 'selected' : ''}`;
        },
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.own_avg_position'),
        key: 'ownAvgPosition_gemini',
        data: 'ownAvgPosition_gemini',
        Component: Cell,
        className: (item) => {
            const isSelected = selectedItems.includes(item?.id);
            const styleClass = isDark ? 'header-platform-column-dark' : 'header-platform-column';
            return `${styleClass} ${isSelected ? 'selected' : ''}`;
        },
        renderCell: ({ data }) => (data !== 'na' ? `${(Number(data) * 100).toFixed(2)}` : '-'),
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.mentions_rate'),
        key: 'mentionsRate_gemini',
        data: 'mentionsRate_gemini',
        Component: Cell,
        className: (item) => {
            const isSelected = selectedItems.includes(item?.id);
            const styleClass = isDark ? 'header-platform-column-dark' : 'header-platform-column';
            return `${styleClass} ${isSelected ? 'selected' : ''}`;
        },
        renderCell: ({ data }) => (data !== 'na' ? `${(Number(data) * 100).toFixed(2)}%` : '-'),
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.own_citation_rate'),
        key: 'ownCitationRate_gemini',
        data: 'ownCitationRate_gemini',
        Component: Cell,
        className: (item) => {
            const isSelected = selectedItems.includes(item?.id);
            const styleClass = isDark ? 'header-platform-column-dark' : 'header-platform-column';
            return `${styleClass} ${isSelected ? 'selected' : ''}`;
        },
        renderCell: ({ data }) => (data !== 'na' ? `${(Number(data) * 100).toFixed(2)}%` : '-'),
    },

    // AIO
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.sov'),
        key: 'SoV_aio',
        data: 'SoV_aio',
        Component: Cell,
    },
    {
        label: (
            <div style={{ whiteSpace: 'pre-line' }}>
                {t('ai_tracking.keyword_detail.prompts.columns.own_urls')}
            </div>
        ),
        key: 'ownURLs_aio',
        data: 'ownURLs_aio',
        Component: Cell,
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.own_avg_position'),
        key: 'ownAvgPosition_aio',
        data: 'ownAvgPosition_aio',
        Component: Cell,
        renderCell: ({ data }) => (data !== 'na' ? `${(Number(data) * 100).toFixed(2)}` : '-'),
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.mentions_rate'),
        key: 'mentionsRate_aio',
        data: 'mentionsRate_aio',
        Component: Cell,
        renderCell: ({ data }) => (data !== 'na' ? `${(Number(data) * 100).toFixed(2)}%` : '-'),
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.own_citation_rate'),
        key: 'ownCitationRate_aio',
        data: 'ownCitationRate_aio',
        Component: Cell,
        renderCell: ({ data }) => (data !== 'na' ? `${(Number(data) * 100).toFixed(2)}%` : '-'),
    },

    // AI Mode
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.sov'),
        key: 'SoV_aimode',
        data: 'SoV_aimode',
        Component: Cell,
        className: (item) => {
            const isSelected = selectedItems.includes(item?.id);
            const styleClass = isDark ? 'header-platform-column-dark' : 'header-platform-column';
            return `${styleClass} ${isSelected ? 'selected' : ''}`;
        },
    },
    {
        label: (
            <div style={{ whiteSpace: 'pre-line' }}>
                {t('ai_tracking.keyword_detail.prompts.columns.own_urls')}
            </div>
        ),
        key: 'ownURLs_aimode',
        data: 'ownURLs_aimode',
        Component: Cell,
        className: (item) => {
            const isSelected = selectedItems.includes(item?.id);
            const styleClass = isDark ? 'header-platform-column-dark' : 'header-platform-column';
            return `${styleClass} ${isSelected ? 'selected' : ''}`;
        },
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.own_avg_position'),
        key: 'ownAvgPosition_aimode',
        data: 'ownAvgPosition_aimode',
        Component: Cell,
        className: (item) => {
            const isSelected = selectedItems.includes(item?.id);
            const styleClass = isDark ? 'header-platform-column-dark' : 'header-platform-column';
            return `${styleClass} ${isSelected ? 'selected' : ''}`;
        },
        renderCell: ({ data }) => (data !== 'na' ? `${(Number(data) * 100).toFixed(2)}` : '-'),
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.mentions_rate'),
        key: 'mentionsRate_aimode',
        data: 'mentionsRate_aimode',
        Component: Cell,
        className: (item) => {
            const isSelected = selectedItems.includes(item?.id);
            const styleClass = isDark ? 'header-platform-column-dark' : 'header-platform-column';
            return `${styleClass} ${isSelected ? 'selected' : ''}`;
        },
        renderCell: ({ data }) => (data !== 'na' ? `${(Number(data) * 100).toFixed(2)}%` : '-'),
    },
    {
        label: t('ai_tracking.keyword_detail.prompts.columns.own_citation_rate'),
        key: 'ownCitationRate_aimode',
        data: 'ownCitationRate_aimode',
        Component: Cell,
        className: (item) => {
            const isSelected = selectedItems.includes(item?.id);
            const styleClass = isDark ? 'header-platform-column-dark' : 'header-platform-column';
            return `${styleClass} ${isSelected ? 'selected' : ''}`;
        },
        renderCell: ({ data }) => (data !== 'na' ? `${(Number(data) * 100).toFixed(2)}%` : '-'),
    },
];
export const EXTRA_COLUMNS = (t, isDark) => [
    { label: '', key: 'select' },
    { label: '', key: 'prompt' },
    { label: '', key: 'checks' },

    // Own
    {
        key: 'ownUniqueURLs',
        label: (
            <div className="ai-table-header" style={{ whiteSpace: 'pre-line' }}>
                {t('ai_tracking.keyword_detail.prompts.columns.own')}
            </div>
        ),
        style: () => ({
            width: '480px',
            zIndex: 3,
            backgroundColor: isDark ? '#3d3f55' : '#f7f7f7',
        }),
    },
    { label: '', key: 'citationsSoV' },
    { label: '', key: 'citationRate' },
    { label: '', key: 'mentions_rate' },

    // ChatGPT
    {
        label: (
            <div className="ai-table-header">
                {showPlatform('chat_gpt')} {t('ai_tracking.keyword_detail.prompts.columns.chatgpt')}
            </div>
        ),
        key: 'SoV_chatgpt',
        style: () => ({
            width: '600px',
            zIndex: 3,
            backgroundColor: isDark ? '#3d3f55' : '#f7f7f7',
        }),
    },
    { label: '', key: 'ownURLs_chatgpt' },
    {
        label: '',
        key: 'ownAvgPosition_chatgpt',
        data: 'ownAvgPosition_chatgpt',
    },
    {
        label: '',
        key: 'mentionsRate_chatgpt',
        data: 'mentionsRate_chatgpt',
    },
    {
        label: '',
        key: 'ownCitationRate_chatgpt',
        data: 'ownCitationRate_chatgpt',
    },

    // Perplexity
    {
        label: (
            <div className="ai-table-header">
                {showPlatform('perplexity')}{' '}
                {t('ai_tracking.keyword_detail.prompts.columns.perplexity')}
            </div>
        ),
        key: 'SoV_perplexity',
        style: () => ({
            width: '600px',
            zIndex: 3,
        }),
    },
    {
        label: '',
        key: 'ownURLs_perplexity',
    },
    {
        label: '',
        key: 'ownAvgPosition_perplexity',
    },
    {
        label: '',
        key: 'mentionsRate_perplexity',
    },
    {
        label: '',
        key: 'ownCitationRate_preplexity',
    },

    // Gemini
    {
        label: (
            <div className="ai-table-header">
                {showPlatform('gemini')} {t('ai_tracking.keyword_detail.prompts.columns.gemini')}
            </div>
        ),
        key: 'SoV_gemini',
        style: () => ({
            width: '600px',
            zIndex: 3,
            backgroundColor: isDark ? '#3d3f55' : '#f7f7f7',
        }),
    },
    { label: '', key: 'ownURLs_gemini' },
    {
        label: '',
        key: 'ownAvgPosition_gemini',
    },
    {
        label: '',
        key: 'mentionsRate_gemini',
    },
    {
        label: '',
        key: 'ownCitationRate_gemini',
    },
    // AIO
    {
        label: (
            <div className="ai-table-header">
                {showPlatform('google_ai_mode')}{' '}
                {t('ai_tracking.keyword_detail.prompts.columns.google_ai_overview')}
            </div>
        ),
        key: 'SoV_aio',
        data: 'SoV_aio',
        style: () => ({
            width: '600px',
            zIndex: 3,
            backgroundColor: isDark ? '#3d3f55' : '#f7f7f7',
        }),
    },
    { label: '', key: 'ownURLs_aio' },
    {
        label: '',
        key: 'ownAvgPosition_aio',
    },
    {
        label: '',
        key: 'mentionsRate_aio',
    },
    {
        label: '',
        key: 'ownCitationRate_aio',
    },

    // AI Mode
    {
        label: (
            <div className="ai-table-header">
                {showPlatform('ai_mode')} {t('ai_tracking.keyword_detail.prompts.columns.ai_mode')}
            </div>
        ),
        key: 'SoV_aimode',
        style: () => ({
            width: '600px',
            zIndex: 3,
        }),
    },
    { label: '', key: 'ownURLs_aimode', data: 'ownURLs_aimode' },
    {
        label: '',
        key: 'ownAvgPosition_aimode',
    },
    {
        label: '',
        key: 'mentionsRate_aimode',
    },
    {
        label: '',
        key: 'ownCitationRate_aimode',
    },
];
